export default "__VITE_ASSET__0cd09518__"